import React from 'react';
import { Form } from 'react-bootstrap';

const ReactstrapFormikTextArea = ({ field: { ...fields }, form: { touched, errors }, ...props }) => {
    const { id, ...rest } = props;
    return (
        <Form.Group controlId={id} className="form-group">
            {props.label && <Form.Label className={'label-color'}>{props.label}</Form.Label>}
            <Form.Control
                {...rest}
                {...fields}
                as="textarea"
                rows={props.rows || 1}
                isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
            />
            {touched[fields.name] && errors[fields.name] && errors[fields.name] !== 'required' && (
                <Form.Control.Feedback className="pb-0 error invalid-feedback d-block" type="invalid">
                    {errors[fields.name]}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};
export default ReactstrapFormikTextArea;
